//scoreRecords
export const OPEN_SCORE_RECORDS_FILTER_MODAL = 'OPEN_SCORE_RECORDS_FILTER_MODAL';
export const CLOSE_SCORE_RECORDS_FILTER_MODAL = 'CLOSE_SCORE_RECORDS_FILTER_MODAL';
export const FILTER_SCORE_RECORDS_LOCALLY = 'FILTER_SCORE_RECORDS_LOCALLY';
export const GET_SCORE_RECORDS = 'GET_SCORE_RECORDS';
export const GET_SCORE_RECORDS_SUCCESS = 'GET_SCORE_RECORDS_SUCCESS';
export const GET_SCORE_RECORDS_FAILED = 'GET_SCORE_RECORDS_FAILED';

//scoreRecord
export const DELETE_SCORE_RECORD = 'DELETE_SCORE_RECORD';
export const DELETE_SCORE_RECORD_SUCCESS = 'DELETE_SCORE_RECORD_SUCCESS';
export const DELETE_SCORE_RECORD_FAILED = 'DELETE_SCORE_RECORD_FAILED';
export const CHANGE_SCORE_RECORD_STATE = 'CHANGE_SCORE_RECORD_STATE';
export const OPEN_UPLOAD_MODAL = 'OPEN_UPLOAD_MODAL';
export const CLOSE_UPLOAD_MODAL = 'CLOSE_UPLOAD_MODAL';
export const CREATE_SCORE_RECORD_FROM_FILE = 'CREATE_SCORE_RECORD_FROM_FILE';
export const CREATE_SCORE_RECORD_FROM_FILE_SUCCESS = 'CREATE_SCORE_RECORD_FROM_FILE_SUCCESS';
export const CREATE_SCORE_RECORD_FROM_FILE_FAILED = 'CREATE_SCORE_RECORD_FROM_FILE_FAILED';
export const UPDATE_SCORE_RECORD = 'UPDATE_SCORE_RECORD';
export const UPDATE_SCORE_RECORD_SUCCESS = 'UPDATE_SCORE_RECORD_SUCCESS';
export const UPDATE_SCORE_RECORD_FAILED = 'UPDATE_SCORE_RECORD_FAILED';
export const GET_SCORE_RECORD_BY_ID = 'GET_SCORE_RECORD_BY_ID';
export const GET_SCORE_RECORD_BY_ID_SUCCESS = 'GET_SCORE_RECORD_BY_ID_SUCCESS';
export const GET_SCORE_RECORD_BY_ID_FAILED = 'GET_SCORE_RECORD_BY_ID_FAILED';
export const CREATE_SCORE_RECORD = 'CREATE_SCORE_RECORD';
export const CREATE_SCORE_RECORD_SUCCESS = 'CREATE_SCORE_RECORD_SUCCESS';
export const CREATE_SCORE_RECORD_FAILED = 'CREATE_SCORE_RECORD_FAILED';

//stores
export const UPDATE_STORES_COLLECTION = 'UPDATE_STORES_COLLECTION';
export const UPDATE_STORES_COLLECTION_SUCCESS = 'UPDATE_STORES_COLLECTION_SUCCESS';
export const UPDATE_STORES_COLLECTION_FAILED = 'UPDATE_STORES_COLLECTION_FAILED';
export const GET_CITIES = 'GET_CITIES';
export const GET_CITIES_SUCCESS = 'GET_CITIES_SUCCESS';
export const GET_CITIES_FAILED = 'GET_CITIES_FAILED';
export const CHANGE_STORES_STATE = 'CHANGE_STORES_STATE';
export const GET_STORES_SUGGESTIONS = 'GET_STORES_SUGGESTIONS';
export const GET_STORES_SUGGESTIONS_SUCCESS = 'GET_STORES_SUGGESTIONS_SUCCESS';
export const GET_STORES_SUGGESTIONS_FAILED = 'GET_STORES_SUGGESTIONS_FAILED';
export const GET_STORES = 'GET_STORES';
export const GET_STORES_SUCCESS = 'GET_STORES_SUCCESS';
export const GET_STORES_FAILED = 'GET_STORES_FAILED';

//criterion
export const DELETE_CRITERION = 'DELETE_CRITERION';
export const DELETE_CRITERION_SUCCESS = 'DELETE_CRITERION_SUCCESS';
export const DELETE_CRITERION_FAILED = 'DELETE_CRITERION_FAILED';
export const CHANGE_CRITERION_STATE = 'CHANGE_CRITERION_STATE';
export const UPDATE_CRITERION = 'UPDATE_CRITERION';
export const UPDATE_CRITERION_SUCCESS = 'UPDATE_CRITERION_SUCCESS';
export const UPDATE_CRITERION_FAILED = 'UPDATE_CRITERION_FAILED';
export const GET_CRITERION_BY_ID = 'GET_CRITERION_BY_ID';
export const GET_CRITERION_BY_ID_SUCCESS = 'GET_CRITERION_BY_ID_SUCCESS';
export const GET_CRITERION_BY_ID_FAILED = 'GET_CRITERION_BY_ID_FAILED';
export const CREATE_CRITERION = 'CREATE_CRITERION';
export const CREATE_CRITERION_SUCCESS = 'CREATE_CRITERION_SUCCESS';
export const CREATE_CRITERION_FAILED = 'CREATE_CRITERION_FAILED';

//criteria
export const GET_CRITERIA_WITH_FILTERS = 'GET_CRITERIA_WITH_FILTERS';
export const GET_CRITERIA_WITH_FILTERS_SUCCESS = 'GET_CRITERIA_WITH_FILTERS_SUCCESS';
export const GET_CRITERIA_WITH_FILTERS_FAILED = 'GET_CRITERIA_WITH_FILTERS_FAILED';
export const CHANGE_CRITERIA_STATE = 'CHANGE_CRITERIA_STATE';
export const GET_CRITERIA = 'GET_CRITERIA';
export const GET_CRITERIA_SUCCESS = 'GET_CRITERIA_SUCCESS';
export const GET_CRITERIA_FAILED = 'GET_CRITERIA_FAILED';

//category
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILED = 'DELETE_CATEGORY_FAILED';
export const CHANGE_CATEGORY_STORE = 'CHANGE_CATEGORY_STORE';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILED = 'UPDATE_CATEGORY_FAILED';
export const GET_CATEGORY_BY_ID = 'GET_CATEGORY_BY_ID';
export const GET_CATEGORY_BY_ID_SUCCESS = 'GET_CATEGORY_BY_ID_SUCCESS';
export const GET_CATEGORY_BY_ID_FAILED = 'GET_CATEGORY_BY_ID_FAILED';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_FAILED = 'CREATE_CATEGORY_FAILED';

//categories
export const GET_CATEGORIES_WITH_FILTERS = 'GET_CATEGORIES_WITH_FILTERS';
export const GET_CATEGORIES_WITH_FILTERS_SUCCESS = 'GET_CATEGORIES_WITH_FILTERS_SUCCESS';
export const GET_CATEGORIES_WITH_FILTERS_FAILED = 'GET_CATEGORIES_WITH_FILTERS_FAILED';
export const CHANGE_CATEGORIES_STATE = 'CHANGE_CATEGORIES_STATE';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILED = 'GET_CATEGORIES_FAILED';

//pillar
export const DELETE_PILLAR = 'DELETE_PILLAR';
export const DELETE_PILLAR_SUCCESS = 'DELETE_PILLAR_SUCCESS';
export const DELETE_PILLAR_FAILED = 'DELETE_PILLAR_FAILED';
export const CHANGE_PILLAR_STATE = 'CHANGE_PILLAR_STATE';
export const UPDATE_PILLAR = 'UPDATE_PILLAR';
export const UPDATE_PILLAR_SUCCESS = 'UPDATE_PILLAR_SUCCESS';
export const UPDATE_PILLAR_FAILED = 'UPDATE_PILLAR_FAILED';
export const GET_PILLAR_BY_ID = 'GET_PILLAR_BY_ID';
export const GET_PILLAR_BY_ID_SUCCESS = 'GET_PILLAR_BY_ID_SUCCESS';
export const GET_PILLAR_BY_ID_FAILED = 'GET_PILLAR_BY_ID_FAILED';
export const CREATE_PILLAR = 'CREATE_PILLAR';
export const CREATE_PILLAR_SUCCESS = 'CREATE_PILLAR_SUCCESS';
export const CREATE_PILLAR_FAILED = 'CREATE_PILLAR_FAILED';

//pillars
export const CHANGE_PILLARS_STATE = 'CHANGE_PILLARS_STATE';
export const GET_PILLARS = 'GET_PILLARS';
export const GET_PILLARS_SUCCESS = 'GET_PILLARS_SUCCESS';
export const GET_PILLARS_FAILED = 'GET_PILLARS_FAILED';

//department
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';
export const DELETE_DEPARTMENT_FAILED = 'DELETE_DEPARTMENT_FAILED';
export const CHANGE_DEPARTMENT_STATE = 'CHANGE_DEPARTMENT_STATE';
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const UPDATE_DEPARTMENT_FAILED = 'UPDATE_DEPARTMENT_FAILED';
export const GET_DEPARTMENT_BY_ID = 'GET_DEPARTMENT_BY_ID';
export const GET_DEPARTMENT_BY_ID_SUCCESS = 'GET_DEPARTMENT_BY_ID_SUCCESS';
export const GET_DEPARTMENT_BY_ID_FAILED = 'GET_DEPARTMENT_BY_ID_FAILED';
export const CREATE_DEPARTMENT = 'CREATE_DEPARTMENT';
export const CREATE_DEPARTMENT_SUCCESS = 'CREATE_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_FAILED = 'CREATE_DEPARTMENT_FAILED';

//departments
export const GET_DEPARTMENTS_WITH_FILTERS = 'GET_DEPARTMENTS_WITH_FILTERS';
export const GET_DEPARTMENTS_WITH_FILTERS_SUCCESS = 'GET_DEPARTMENTS_WITH_FILTERS_SUCCESS';
export const GET_DEPARTMENTS_WITH_FILTERS_FAILED = 'GET_DEPARTMENTS_WITH_FILTERS_FAILED';
export const CHANGE_DEPARTMENTS_STATE = 'CHANGE_DEPARTMENTS_STATE';
export const GET_DEPARTMENTS = 'GET_DEPARTMENTS';
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENTS_FAILED = 'GET_DEPARTMENTS_FAILED';

//roles
export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAIL = 'GET_ROLES_FAIL';

//person
export const DELETE_PERSON =  'DELETE_PERSON';
export const DELETE_PERSON_SUCCESS =  'DELETE_PERSON_SUCCESS';
export const DELETE_PERSON_FAILED =  'DELETE_PERSON_FAILED';
export const RESET_PASSWORD =  'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS =  'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED =  'RESET_PASSWORD_FAILED';
export const CHANGE_PERSON_STATE =  'CHANGE_PERSON_STATE';
export const UPDATE_PERSON =  'UPDATE_PERSON';
export const UPDATE_PERSON_SUCCESS =  'UPDATE_PERSON_SUCCESS';
export const UPDATE_PERSON_FAILED =  'UPDATE_PERSON_FAILED';
export const GET_PERSON_BY_ID =  'GET_PERSON_BY_ID';
export const GET_PERSON_BY_ID_SUCCESS =  'GET_PERSON_BY_ID_SUCCESS';
export const GET_PERSON_BY_ID_FAILED =  'GET_PERSON_BY_ID_FAILED';
export const CREATE_PERSON =  'CREATE_PERSON';
export const CREATE_PERSON_SUCCESS =  'CREATE_PERSON_SUCCESS';
export const CREATE_PERSON_FAIL =  'CREATE_PERSON_FAIL';

//persons
export const GET_PERSONS = 'GET_PERSONS';
export const GET_PERSONS_SUCCESS = 'GET_PERSONS_SUCCESS';
export const GET_PERSONS_FAIL = 'GET_PERSONS_FAIL';

//loggedInPerson
export const LOG_OUT = 'LOG_OUT';
export const lOG_OUT_SUCCESS = 'lOG_OUT_SUCCESS';
export const LOG_OUT_FAIL = 'LOG_OUT_FAIL';
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const CHANGE_USER_STORE_SETTINGS = 'CHANGE_USER_STORE_SETTINGS';

//general
export const RESET_STATE = 'RESET_STATE';
export const OPEN_DRAWER = 'OPEN_DRAWER';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';



// WEBPACK FOOTER //
// ./src/actions/types.js